module.exports = __webpack_public_path__ + "static/media/diamond.8e369cb7.png";